module.exports = __webpack_public_path__ + "static-portal/img/44-1.fefcee0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/44-1.jpg
// module id = agsX
// module chunks = 4